import { Text, VStack } from '@chakra-ui/react'
import React from 'react'
import { CustomDateInput } from './customDate'

interface ModalDateInputProps {
  label?: string
  required?: boolean
  value: Date | null
  onChange: (value: Date | null) => void
  placeholder?: string
  shouldDisableDate?: (date: Date) => boolean
}

const ModalDateInput: React.FC<ModalDateInputProps> = ({
  label,
  required,
  value,
  onChange,
  placeholder,
  shouldDisableDate,
}) => {
  return (
    <VStack align="left" spacing="4px" width="100%">
      {label && (
        <Text textStyle="l-xs" color={required ? 'solid.700' : 'solid.500'} fontWeight={required ? '600' : undefined}>
          {label}
          {required && <Text as="span" color="primary.100"> *</Text>}
        </Text>
      )}
      <CustomDateInput
        defaultValue={value}
        onChange={onChange}
        placeholder={placeholder}
        shouldDisableDate={shouldDisableDate}
      />
    </VStack>
  )
}

export default ModalDateInput
